<template>
    <div class="content-box">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'ContentBox',
        data: function () {
            return {};
        },
        methods: {},
    };
</script>

<style lang="scss">
    .content-box {
        width: calc(100% - #{$margin * 4});
        border-radius: 15px;
        margin-left: $margin;
        margin-right: $margin;
        margin-bottom: 10px;
        padding: $margin;
        background-color: $white;
        text-align: left;

        h3 {
            font-size: 16px;
            line-height: 24px;
            margin: 0;
        }

        p {
            margin: 24px 0 0 0;

            &.first {
                margin: 0;
            }
        }

        a {
            color: $dark-green;
            word-break: break-all;
        }
    }
</style>
